export const assetsMap = {
  "intrigue-rf-250-cl": {
    name: "Intrigue RF 250 CL",
    assetId: "2e05c1ce-93e4-4577-8ddf-d2cb73dfd5a3",
  },
  Sunsation_RC_230_DL: {
    name: "Sunsation RC 230 DL",
    assetId: "a62ad1e0-d400-432c-bdae-ef7033167114",
  },
  Boundary_Waters_REV_WALK_ON_310_CL: {
    name: "Boundary Waters REV WALK ON 310 CL",
    assetId: "489079a5-6242-480e-bda9-b97c7b58325a",
  },
  S_Series_250_CL: {
    name: "S Series 250 CL",
    assetId: "d5f420aa-0ea8-4a40-bb41-5bda45614c78",
  },
  Grand_View_290_DL: {
    name: "Grand View 290 DL",
    assetId: "cd595fcc-a089-42df-856e-804ddca1b281",
  },
  Accolade_310_CL: {
    name: "Accolade 310 CL",
    assetId: "cee4a78f-0ac1-49a5-8b13-e820ab901a88",
  },
  "intrigue-rl-230-cl": {
    name: "Intrigue RL 230 CL",
    assetId: "ffbec025-fddc-4604-8a53-063a396f38f3",
  },
  Escalante_310_CL: {
    name: "Escalante 310 CL ",
    assetId: "052745e5-31ee-4c4a-96f8-ec39eda53ba2",
  },
  Grand_Entertainer_250: {
    name: "Grand Entertainer 250 CL",
    assetId: "1755e4ac-cbe7-420d-bea9-9d135cbb2d51",
  },
  Sunsation_RL_230_CL: {
    name: "Sunsation RL 230 CL",
    assetId: "23653e49-86bb-48fa-900b-5668d92b4c59",
  },
  Castaway_250_CL: {
    name: "Castaway 250 CL",
    assetId: "2551fdcc-3a78-4d77-9aae-71d7609b1ed9",
  },
  Solaris_REV_250_CL: {
    name: "Solaris REV 250 CL",
    assetId: "2e644d3e-c4f8-4d61-a968-d5b5f51fb6d8",
  },
  Intrigue_Rev_270_CL: {
    name: "Intrigue REV 270 CL",
    assetId: "f5ef865d-03bb-4408-887e-2613e8a46c96",
  },
  Boundary_Waters_250_CL: {
    name: "Boundary Waters 250 CL",
    assetId: "54c348ee-fde0-4ee9-a70d-2c8ac711868a",
  },
  Grand_Majestic_RE_250_CL: {
    name: "Grand Majestic RE 250 CL",
    assetId: "a380dd09-dc3b-4e97-acf2-f0496feaee9a",
  },
  Sunspree_RF_230_CL: {
    name: "Sunspree RF 230 CL",
    assetId: "3286bdae-e6aa-4dbe-bae8-7d1154a94c74",
  },
};
